import { createContext } from 'react';

import type { IPageLayoutContext } from './types';

export default createContext<IPageLayoutContext>({});
